import tradeConcernApi from './TradeConcernApi.js';
import tradeConcernCommonApi from './TradeConcernCommonApi.js';
var qs = require('querystring');

export default {
	getAll: async (parameter) => {
		return await tradeConcernApi().get('/v1/stcs/search', {
			params: parameter,
			paramsSerializer: (params) => {
				return qs.stringify(params);
			}
		})
			.then((response) => {
				if (response.status == 200) {
					return response.data;
				} else {
					console.log(response);
					return {};
				}
			})
			.catch((error) => {
				console.log(error);
				return {};
			});
	},
	exportToExcel: async (parameter) => {
		return await tradeConcernApi().get('/v1/stcs/exportToExcel', {
			params: parameter,
			paramsSerializer: (params) => {
				return qs.stringify(params);
			},
			responseType: 'blob',
		})
			.then((response) => {
				if (response.status == 200) {
					let fileURL = window.URL.createObjectURL(new Blob([response.data]));
					let fileLink = document.createElement('a');

					fileLink.href = fileURL;
					fileLink.setAttribute('download', 'Trade Concerns.xlsx');
					document.body.appendChild(fileLink);
					fileLink.click();
				} else {
					console.log(response);
					return {};
				}
			})
			.catch((error) => {
				console.log(error);
				return {};
			});
	},
	getRelated: async (parameter) => {
		return await tradeConcernApi().get('/v1/stcs/getRelated', {
			params: parameter,
			paramsSerializer: (params) => {
				return qs.stringify(params);
			}
		})
			.then((response) => {
				if (response.status == 200) {
					return response.data;
				} else {
					console.log(response);
					return {};
				}
			})
			.catch((error) => {
				console.log(error);
				return {};
			});

	},
	//Member Profile
	getMemberTypeCounter: async (parameter) => {
		return await tradeConcernApi().get('/v1/members/getMemberTypeCounters', {
			params: parameter,
			paramsSerializer: (params) => {
				return qs.stringify(params);
			}
		})
			.then((response) => {
				if (response.status == 200) {
					return response.data;
				} else {
					console.log(response);
					return {};
				}
			})
			.catch((error) => {
				console.log(error);
				return {};
			});

	},
	getMemberProfileNumberOfTimesRaised: async (parameter) => {
		return await tradeConcernApi().get('/v1/members/getMemberProfileNumberOfTimesRaised', {
				params: parameter,
				paramsSerializer: (params) => {
					return qs.stringify(params);
				}
			})
			.then((response) => {
				if (response.status == 200) {
					return response.data;
				} else {
					console.log(response);
					return {};
				}
			})
			.catch((error) => {
				console.log(error);
				return {};
			});
	},
	getHSCodes: async (parameter) => {
		return await tradeConcernApi().get('/v1/stcs/getHSCodes', {
				params: parameter,
				paramsSerializer: (params) => {
					return qs.stringify(params);
				}
			})
			.then((response) => {
				if (response.status == 200) {
					return response.data;
				} else {
					console.log(response);
					return {};
				}
			})
			.catch((error) => {
				console.log(error);
				return {};
			});
	},
	getMemberProfileChartItem: async (parameter) => {
		return await tradeConcernApi().get('/v1/members/getMemberProfileChartItem', {
				params: parameter,
				paramsSerializer: (params) => {
					return qs.stringify(params);
				}
			})
			.then((response) => {
				if (response.status == 200) {
					return response.data;
				} else {
					console.log(response);
					return {};
				}
			})
			.catch((error) => {
				console.log(error);
				return {};
			});
	},
	//Home
	getNumberOfStcByArea: async (parameter) => {
		return await tradeConcernApi().get('/v1/stcs/getNumberOfStcByArea', {
				params: parameter,
				paramsSerializer: (params) => {
					return qs.stringify(params);
				}
			})
			.then((response) => {
				if (response.status == 200) {
					return response.data;
				} else {
					console.log(response);
					return {};
				}
			})
			.catch((error) => {
				console.log(error);
				return {};
			});
	},
	//Parameter
	// -- Meeting Years --
	getMeetingYearsForTreeView: async () => {
		return await tradeConcernApi().get('/v1/meetings/getForTreeview', {
				params: { language: "English" },
				paramsSerializer: (params) => {
					return qs.stringify(params);
				}
			})
			.then((response) => {
				if (response.status == 200) {
					return response.data;
				} else {
					console.log(response);
					return {};
				}
			})
			.catch((error) => {
				console.log(error);
				return {};
			});
	},
	//Details
	getTradeConcernDetails: async (parameter) => {
		return await tradeConcernApi().get('/v1/stcs/getDetails', {
				params: parameter,
				paramsSerializer: (params) => {
					return qs.stringify(params);
				}
			})
			.then((response) => {
				if (response.status === 200) {
					return response.data;
				} else {
					console.log(response);
					return {};
				}
			})
			.catch((error) => {
				console.log(error);
				return {};
			});
	},
	//Static Content
	getTradeConcernStaticContent: async (parameter) => {
		return await tradeConcernCommonApi().get('/v1/staticContents/getOne', {
				params: parameter,
				paramsSerializer: (params) => {
					return qs.stringify(params);
				}
			})
			.then((response) => {
				if (response.status === 200) {
					return response.data;
				} else {
					console.log(response);
					return {};
				}
			})
			.catch((error) => {
				console.log(error);
				return {};
			});
	},
	// Full Text Search Display Terms
	getFullTextSearchDisplayTerms: async (parameter) => {
		return await tradeConcernApi().get('/v1/stcs/getFullTextSearchDisplayTerms', {
				params: parameter,
				paramsSerializer: (params) => {
					return qs.stringify(params);
				}
			})
			.then((response) => {
				if (response.status === 200) {
					return response.data;
				} else {
					console.log(response);
					return {};
				}
			})
			.catch((error) => {
				console.log(error);
				return {};
			});
	},
	getObjectivesForDropdown: async (parameter) => {
		return await tradeConcernApi().get('/v1/objectives/getForDropdown', {
			params: parameter,
			paramsSerializer: (params) => {
				return qs.stringify(params);
			}
		})
			.then((response) => {
				if (response.status === 200) {
					return response.data;
				} else {
					console.log(response);
					return {};
				}
			})
			.catch((error) => {
				console.log(error);
				return {};
			});
	},
	getKeywordsForDropdown: async (parameter) => {
		return await tradeConcernApi().get('/v1/keywords/getForDropdown', {
			params: parameter,
			paramsSerializer: (params) => {
				return qs.stringify(params);
			}
		})
			.then((response) => {
				if (response.status === 200) {
					return response.data;
				} else {
					console.log(response);
					return {};
				}
			})
			.catch((error) => {
				console.log(error);
				return {};
			});
	},
}